import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { errMsg, useAdminApi } from "@/lib/api";

const DESC = { admin: "Full access including enquiries and user roles", editor: "Manage teams, matches, news, gallery and settings", member: "No dashboard access" };

export default function UsersPage() {
  const req = useAdminApi();
  const [d, setD] = useState({ roles: [], users: [] });
  const load = useCallback(() => req("get", "/users").then(setD).catch((e) => toast.error(errMsg(e))), [req]);
  useEffect(() => { load(); }, [load]);
  const change = async (uid, role) => {
    try { await req("patch", `/users/${uid}/role`, { role }); toast.success("Role updated"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="admin-users" className="space-y-6">
      <div><h1 className="font-display text-4xl uppercase">Admin users</h1>
        <p className="mt-1 text-sm text-slate-400">People who sign in at /sign-in appear here. New accounts have no access until you assign a role.</p></div>
      <ul className="grid gap-2 text-sm text-slate-400 sm:grid-cols-3">{Object.entries(DESC).map(([r, t]) => <li key={r} className="rounded-md border border-white/10 p-3"><b className="uppercase text-white">{r}</b> — {t}</li>)}</ul>
      <div className="overflow-x-auto rounded-md border border-white/10">
        <table className="w-full min-w-[560px] text-left text-sm">
          <thead className="bg-[#112240] text-[11px] uppercase tracking-widest text-slate-400"><tr><th className="p-3">Email</th><th className="p-3">Name</th><th className="p-3">Role</th></tr></thead>
          <tbody className="divide-y divide-white/5">
            {d.users.map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`}>
                <td className="p-3">{u.email || u.user_id}</td><td className="p-3">{u.name || "—"}</td>
                <td className="p-3">
                  <Select value={u.role} onValueChange={(r) => change(u.user_id, r)}>
                    <SelectTrigger className="w-40 rounded-sm border-white/15 bg-[#0A192F]" data-testid={`user-role-${u.user_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent className="border-white/15 bg-[#112240] text-white">{d.roles.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
